export default __webpack_public_path__ + "static/20210909_ARTIFICIAL_HYBRID_LOOP_01_CAM-03_1080-8f40331fe181884b62fafdd637b41a02.mp4";